import React, { useEffect, useState } from "react";

import {
  ActiveCitizenship,
  AscBadgeSkillsType,
  Communication,
  Employability,
  Learning,
  PersonalDevelopment,
} from "@ascendnow/shared";
import {
  CooperationBadge,
  CreativityBadge,
  CriticalThinkingBadge,
  CultureBadge,
  DigitalLiteracyBadge,
  DivergentThinkingBadge,
  EmpathyBadge,
  FinancialLiteracyBadge,
  LearningToLearnBadge,
  NegotiationBadge,
  NetworkingBadge,
  ParticipationBadge,
  PersonalBrandingBadge,
  PositiveMindsetBadge,
  PresentationSkillsBadge,
  ProblemSolvingBadge,
  ResearchBadge,
  ResilienceBadge,
  SelfDevelopmentBadge,
  VerbalAndNonVerbalBadge,
  VisualCommunicationBadge,
  WorkEfficiencyBadge,
  WrittenCommunicationBadge,
} from "../../assets/icons/badges";

interface AscBadgeSkillsProps extends React.SVGProps<SVGSVGElement> {
  badge: AscBadgeSkillsType;
}

export default function AscBadgeSkills({
  badge,
  ...props
}: AscBadgeSkillsProps) {
  const [badgeElement, setBadgeElement] = useState<JSX.Element>(
    <div>Badge not found!</div>
  );

  useEffect(() => {
    const handleActiveCitizenship = () => {
      switch (badge.activeCitizenship) {
        case ActiveCitizenship.CULTURE:
          setBadgeElement(<CultureBadge {...props} />);
          break;
        case ActiveCitizenship.EMPATHY:
          setBadgeElement(<EmpathyBadge {...props} />);
          break;
        case ActiveCitizenship.PARTICIPATION:
          setBadgeElement(<ParticipationBadge {...props} />);
          break;
        case ActiveCitizenship.RESPECT:
          setBadgeElement(<ResearchBadge {...props} />);
          break;
      }
    };

    const handleCommunication = () => {
      switch (badge.communication) {
        case Communication.PRESENTATION_SKILLS:
          setBadgeElement(<PresentationSkillsBadge {...props} />);
          break;
        case Communication.VERBAL_AND_NON_VERBAL:
          setBadgeElement(<VerbalAndNonVerbalBadge {...props} />);
          break;
        case Communication.VISUAL_COMMUNICATION:
          setBadgeElement(<VisualCommunicationBadge {...props} />);
          break;
        case Communication.WRITTEN_COMMUNICATION:
          setBadgeElement(<WrittenCommunicationBadge {...props} />);
          break;
      }
    };

    const handleEmployability = () => {
      switch (badge.employability) {
        case Employability.COOPERATION:
          setBadgeElement(<CooperationBadge {...props} />);
          break;
        case Employability.DIGITAL_LITERACY:
          setBadgeElement(<DigitalLiteracyBadge {...props} />);
          break;
        case Employability.NEGOTIATION:
          setBadgeElement(<NegotiationBadge {...props} />);
          break;
        case Employability.NETWORKING:
          setBadgeElement(<NetworkingBadge {...props} />);
          break;
        case Employability.WORK_EFFICIENCY:
          setBadgeElement(<WorkEfficiencyBadge {...props} />);
          break;
      }
    };

    const handleLearning = () => {
      switch (badge.learning) {
        case Learning.CREATIVITY:
          setBadgeElement(<CreativityBadge {...props} />);
          break;
        case Learning.CRITICAL_THINKING:
          setBadgeElement(<CriticalThinkingBadge {...props} />);
          break;
        case Learning.DIVERGENT_THINKING:
          setBadgeElement(<DivergentThinkingBadge {...props} />);
          break;
        case Learning.LEARNING_TO_LEARN:
          setBadgeElement(<LearningToLearnBadge {...props} />);
          break;
        case Learning.PROBLEM_SOLVING:
          setBadgeElement(<ProblemSolvingBadge {...props} />);
          break;
        case Learning.RESEARCH:
          setBadgeElement(<ResearchBadge {...props} />);
          break;
      }
    };

    const handlePersonalDevelopment = (val: PersonalDevelopment) => {
      switch (val) {
        case PersonalDevelopment.FINANCIAL_LITERACY:
          setBadgeElement(<FinancialLiteracyBadge {...props} />);
          break;
        case PersonalDevelopment.PERSONAL_BRANDING:
          setBadgeElement(<PersonalBrandingBadge {...props} />);
          break;
        case PersonalDevelopment.POSITIVE_MINDSET:
          setBadgeElement(<PositiveMindsetBadge {...props} />);
          break;
        case PersonalDevelopment.RESILIENCE:
          setBadgeElement(<ResilienceBadge {...props} />);
          break;
        case PersonalDevelopment.SELF_DEVELOPMENT:
          setBadgeElement(<SelfDevelopmentBadge {...props} />);
          break;
      }
    };

    if (badge) {
      badge?.activeCitizenship && handleActiveCitizenship();
      badge?.communication && handleCommunication();
      badge?.employability && handleEmployability();
      badge?.learning && handleLearning();
      badge?.personalDevelopment &&
        handlePersonalDevelopment(badge.personalDevelopment);
    }
  }, [badge, props]);

  return badgeElement;
}
